var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.1667 17.0807H5.83341C3.33341 17.0807 1.66675 15.8307 1.66675 12.9141V7.08073C1.66675 4.16406 3.33341 2.91406 5.83341 2.91406H14.1667C16.6667 2.91406 18.3334 4.16406 18.3334 7.08073V12.9141C18.3334 15.8307 16.6667 17.0807 14.1667 17.0807Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99973 10.722C9.29973 10.722 8.5914 10.5054 8.04974 10.0637L5.4414 7.98038C5.17473 7.76371 5.12474 7.37204 5.3414 7.10538C5.55807 6.83871 5.94974 6.78871 6.21641 7.00538L8.82473 9.08871C9.45806 9.59705 10.5331 9.59705 11.1664 9.08871L13.7747 7.00538C14.0414 6.78871 14.4414 6.83038 14.6497 7.10538C14.8664 7.37204 14.8247 7.77205 14.5497 7.98038L11.9414 10.0637C11.4081 10.5054 10.6997 10.722 9.99973 10.722Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon12);
export default __webpack_public_path__ + "static/media/menu-icon-12.f1d538ae7c6f9ede6e73a612e5716102.svg";
export { ForwardRef as ReactComponent };